import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-document-viewer',
    templateUrl: './document-viewer.component.html',
    styleUrls: ['./document-viewer.component.scss']
})
export class DocumentViewerComponent implements OnInit {
    public fileUrl!: any;

    constructor(private route: ActivatedRoute, public sanitizer: DomSanitizer) {}

    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            this.fileUrl = this.sanitizer.bypassSecurityTrustUrl(params['fileUrl']);
            //console.log('FileURL', this.fileUrl);
        });
    }
}
